import auth from './auth.js';
import router from '../versa/router.js';
import db from '../versa/db.js';
import shell from './views/shell.js';
import about from './views/about.js';

// Título da aba por ambiente (hostname da página, não API_BASE)
if (typeof window !== 'undefined' && (window.location.hostname === '10.10.0.219' || window.location.hostname === 'qa.sial.run'))
	document.title = 'QA SIAL';
import companies from './cruds/companies.js';
import suppliers from './cruds/suppliers.js';
import customers from './cruds/customers.js';
import customer_routes from './cruds/customer-routes.js';
import carriers from './cruds/carriers.js';
import devices from './cruds/devices.js';
import input_docks from './cruds/input-docks.js';
import units from './cruds/units.js';
import classes from './cruds/classes.js';
import categories from './cruds/categories.js';
import manufacturers from './cruds/manufacturers.js';
import products from './cruds/products.js';
import product_packagings from './cruds/product-packagings.js';
import warehouses from './cruds/warehouses.js';
import locations from './cruds/locations.js';
import stocks from './cruds/stocks.js';
import stock_management from './cruds/stock-management.js';
import transactions from './cruds/transactions.js';
import movements from './cruds/movements.js';
import dock_expedition from './cruds/dock-expedition.js';
import input_dock_schedules from './cruds/input-dock-schedules.js';
import picking_waves from './cruds/picking-waves.js';
import replenishment_rules from './cruds/replenishment-rules.js';
import replenishment_orders from './cruds/replenishment-orders.js';
import inventories from './cruds/inventory-sessions.js';
import input_orders from './cruds/input-orders.js';
import output_orders from './cruds/output-orders.js';
import inputs from './cruds/inputs.js';
import lots from './cruds/lots.js';
import outputs from './cruds/outputs.js';
import output_picking_boxes from './cruds/output-picking-boxes.js';
import output_picking_countbacks from './cruds/output-picking-countbacks.js';
import price_lists from './cruds/price-lists.js';
import payment_terms from './cruds/payment-terms.js';
import cfops from './cruds/cfops.js';
import programs from './cruds/programs.js';
import receipt_types from './cruds/receipt-types.js';
import input_cancel_reasons from './cruds/input-cancel-reasons.js';
import stock_block_kinds from './cruds/stock-block-kinds.js';
import invoices from './cruds/invoices.js';
import invoice_lots from './cruds/invoice-lots.js';
import nfe_emission_control from './cruds/nfe-emission-control.js';
import groups from './cruds/groups.js';
import users from './cruds/users.js';
import audit_logs from './cruds/audit-logs.js';
import integration_events from './cruds/integration-events.js';
import import_center from './views/import-center.js';
import bi_kardex from './views/bi-kardex.js';
import bi_stock_analytical from './views/bi-stock-analytical.js';
import bi_stock_blocks_descriptive from './views/bi-stock-blocks-descriptive.js';
import bi_audit from './views/bi-audit.js';
import bi_output_lines from './views/bi-output-lines.js';
import bi_output_productivity from './views/bi-output-productivity.js';
import invoices_billed_exclusive from './views/invoices-billed-exclusive.js';
import expiring_items from './views/expiring-items.js';
import especial_faturas from './views/especial-faturas.js';
import { fetchEspecialAcl, applyEspecialMenuAcl } from './utils/especial-acl.js';

router.set('#companies', companies);
router.set('#suppliers', suppliers);
router.set('#customers', customers);
router.set('#customer-routes', customer_routes);
router.set('#carriers', carriers);
router.set('#devices', devices);
router.set('#input-docks', input_docks);
router.set('#units', units);
router.set('#classes', classes);
router.set('#categories', categories);
router.set('#manufacturers', manufacturers);
router.set('#products', products);
router.set('#product-packagings', product_packagings);
router.set('#warehouses', warehouses);
router.set('#locations', locations);
router.set('#stocks', stocks);
router.set('#stock-management', stock_management);
router.set('#transactions', transactions);
router.set('#movements', movements);
router.set('#dock-expedition', dock_expedition);
router.set('#input-dock-schedules', input_dock_schedules);
router.set('#picking-waves', picking_waves);
router.set('#replenishments', replenishment_rules);
router.set('#replenishment-orders', replenishment_orders);
router.set('#goto-replenishment-orders', () => {
	location.hash = '';
	location.hash = '#replenishment-orders';
});
router.set('#goto-replenishment-rules', () => {
	location.hash = '';
	location.hash = '#replenishments';
});
router.set('#inventories', inventories);
router.set('#input-orders', input_orders);
router.set('#output-orders', output_orders);
router.set('#inputs', inputs);
router.set('#lots', lots);
router.set('#outputs', outputs);
router.set('#output-picking-boxes', output_picking_boxes);
router.set('#output-picking-countbacks', output_picking_countbacks);
router.set('#price-lists', price_lists);
router.set('#payment-terms', payment_terms);
router.set('#cfops', cfops);
router.set('#programs', programs);
router.set('#receipt-types', receipt_types);
router.set('#input-cancel-reasons', input_cancel_reasons);
router.set('#stock-block-kinds', stock_block_kinds);
router.set('#invoices', invoices);
router.set('#invoice-lots', invoice_lots);
router.set('#nfe-emission-control', nfe_emission_control);
router.set('#groups', groups);
router.set('#users', users);
router.set('#logs', audit_logs);
router.set('#integration-events', integration_events);
router.set('#logout', auth.logout);
router.set('#about', about);
router.set('#import-center', import_center);
router.set('#bi-kardex', bi_kardex);
router.set('#bi-stock-analytical', bi_stock_analytical);
router.set('#bi-stock-blocks-descriptive', bi_stock_blocks_descriptive);
router.set('#bi-audit', bi_audit);
router.set('#bi-output-lines', bi_output_lines);
router.set('#bi-output-productivity', bi_output_productivity);
router.set('#invoices-billed-exclusive', invoices_billed_exclusive);
router.set('#expiring-items', expiring_items);
router.set('#especial-faturas', especial_faturas);
router.set('#especial-sessp-faturas', especial_faturas);

const loadShell = function()
{
	db.define([
		{ store: 'endpoints', keys: [ 'id', 'name' ] },
		{ store: 'groups', keys: [ 'id', 'name' ] },
		{ store: 'users', keys: [ 'id', 'username' ] },
		{ store: 'cities', keys: [ 'id', ['state', 'city'], 'state' ] },
		{ store: 'companies', keys: [ 'id', 'name' ] },
		{ store: 'all_companies', keys: [ 'id', 'name' ] },
		{ store: 'warehouses', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'locations', keys: [ ['company_id', 'warehouse_id', 'id'], ['company_id', 'warehouse_id', 'address'] ] },
		{ store: 'units', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'classes', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'categories', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'manufacturers', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'programs', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'receipt_types', keys: [ ['company_id', 'id'], ['company_id', 'code'] ] },
		{ store: 'input_docks', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'input_cancel_reasons', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'stock_block_kinds', keys: [ ['company_id', 'code'] ] },
		{ store: 'customer_routes', keys: [ ['company_id', 'id'], ['company_id', 'code'] ] },
		{ store: 'products', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'product_packagings', keys: [ ['company_id', 'id'], ['company_id', 'product_id'] ] },
		{ store: 'lots', keys: [ ['company_id', 'id'], ['company_id', 'product_id'] ] },
		{ store: 'payment_terms', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'price_lists', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'suppliers', keys: [ ['company_id', 'id'], ['company_id', 'nick'] ] },
		{ store: 'customers', keys: [ ['company_id', 'id'], ['company_id', 'nick'] ] },
		{ store: 'carriers', keys: [ ['company_id', 'id'], ['company_id', 'nick'] ] },
		{ store: 'devices', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'cfops', keys: [ ['company_id', 'id'], ['company_id', 'code'] ] },
		{ store: 'class_tribs', keys: [ 'code', 'name' ] },
	], 'sial', 7);
	let name = sessionStorage.username.split('.').map(name => name[0].toLocaleUpperCase() + name.slice(1));		// Always first.last
	document.body.innerHTML = shell(`${name[0]} ${name[1] || ''}`);
	fetchEspecialAcl().then(applyEspecialMenuAcl);
	document.querySelector('.menu').addEventListener('click', (ev) =>
	{
		const item = ev.target.closest('[hash]');
		if (!item || !ev.currentTarget.contains(item))
			return;
		const hash = item.getAttribute('hash');
		if (!hash)
			return;
		location.hash = '';
		location.hash = hash;
	});
	if (!sessionStorage.reset)
	{
		db.init();
		sessionStorage.setItem('reset', 'true');
	}
	router.init();
}

if (!sessionStorage.username)
	auth.login(loadShell);
else
	loadShell();

